module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAA1CAYAAADCvfKlAAAAAXNSR0IArs4c6QAAAIpJREFUaEPt2bEJwDAMBdF4A2n/ITVCAi7cuDEHBgUudc6Yl99lRMT7NH3GLy5XVW38MnPeZcl5ucNvo9wh1PaacspRAdq5OeWoAO3cnHJUgHZuTjkqQDs3pxwVoJ2bU44K0M7NKUcFaOfmlKMCtHNzylEB2rk55agA7dycclSAdtvm6EE3u9a/0T806NHxn5KeAwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/crop/three-to-four.png
// module id = df3W
// module chunks = 3